// src/app/AppShell.tsx
import { Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect, useState, useSyncExternalStore } from "react";

import { useQuery } from "@tanstack/react-query";

import { accessQuery } from "@/auth/queries";
import { session } from "@/auth/session";
import { MaintenanceScreen } from "@/features/system/MaintenanceScreen";
import { SystemBanner } from "@/features/system/SystemBanner";
import { systemStatusQuery } from "@/features/system/api";

import { Header } from "./Header";
import { Sidebar } from "./Sidebar";

export function AppShell() {
  const navigate = useNavigate();
  const [drawer, setDrawer] = useState(false);
  const authed = useSyncExternalStore(session.subscribe, session.isValid);

  // انتهاء الجلسة (مؤقت، 401، أو سحب من القناة اللحظية) يرجع المستخدم لصفحة الدخول
  // (لو انتهى رمز الوصول وبقي رمز التجديد نجدّد بدل ما نطرده)
  useEffect(() => {
    if (authed) return;
    void session.ensure().then((ok) => {
      if (!ok) void navigate({ to: "/login", search: { redirect: location.pathname } });
    });
  }, [authed, navigate]);

  const status = useQuery(systemStatusQuery).data;
  const access = useQuery({ ...accessQuery, enabled: authed && !!status?.maintenance });
  const isAdmin = !!access.data?.is_platform_admin;
  if (status?.maintenance && authed && !access.isLoading && !isAdmin) return <MaintenanceScreen />;

  return (
    <div dir="rtl" className="app-bg flex min-h-screen items-stretch">
      <div className="sticky top-0 hidden self-start lg:block"><Sidebar /></div>
      {drawer && (
        <div className="fixed inset-0 z-40 lg:hidden" onClick={() => setDrawer(false)} style={{ background: "rgba(2,8,14,.7)" }}>
          <div className="w-[240px]" onClick={(e) => e.stopPropagation()}><Sidebar onNavigate={() => setDrawer(false)} /></div>
        </div>
      )}
      <main className="flex min-w-0 flex-1 flex-col">
        <SystemBanner adminNote={isAdmin} />
        <Header onMenu={() => setDrawer(true)} />
        <div className="flex flex-col gap-[22px] px-[26px] pb-[60px] pt-[26px]"><Outlet /></div>
      </main>
    </div>
  );
}
